module.exports = __webpack_public_path__ + "static/media/usb-drive.cf0479fc.svg";